export type Representation = "temperature" | "wind" | "snow";

export const REPRESENTATIONS: Representation[] = [
  "temperature",
  "wind",
  "snow",
];
